import axios from '@/helpers/axios'

export default {
  /**
   * 获取充电桩列表
   *
   * @param {object} query 查询
   * @param {string} query.keyword 关键字查询
   * @param {string} query.created_at 时间范围查询
   * @returns {Promise<object>} 格式 { ev_charging_piles: [] }
   */
  getEntities(query) {
    return axios.get('/backend/ev_charging_piles', { query: query })
  },
  /**
   *
   * 获取充电桩的信息
   *
   * @param {string} id 充电桩Id
   * @returns {Promise<object>} 格式 { ev_charging_pile }
   */
  getEntity(id) {
    return axios.get(`/backend/ev_charging_piles/${id}`)
  },
  /**
   *
   * 创建充电桩
   *
   * @param {object} params 参数
   * @param {string} params.name 桩名
   * @param {string} params.serial_number 编号
   * @param {string} params.created_at 创建时间
   * @param {string} params.updated_at 更新时间
   * @param {string} params.guns_count 枪口数量
   * @param {string} params.description 备注
   * @param {string} params.ev_charging_station 所属充电站
   * @param {string} params.charger_brand 桩品牌
   * @param {string} params.device_name 设备名称
   * @param {string} params.product_name 产品名称
   * @param {string} params.product_model 型号
   * @param {string} params.manufactured_number 出厂编号
   * @param {string} params.manufactured_date 出厂日期
   * @param {string} params.manufacturer 制造商
   * @param {string} params.plug 插头
   * @param {string} params.charging_mode 充电模式
   * @param {string} params.phase_number 相数
   * @param {string} params.certification 质量认证
   * @param {string} params.protection_level 防护等级
   * @param {string} params.temperature 工作温度
   * @param {string} params.standard 标准
   * @param {string} params.status 状态
   * @param {string} params.business_status 业务状态
   * @param {string} params.open 是否开放
   * @param {string} params.charger_type 电桩类型
   * @param {string} params.plug_type 枪口类型
   * @param {string} params.max_power 最大输出功率
   * @param {string} params.max_current 最大输出电流
   * @param {string} params.input_voltage 输入电压
   * @param {string} params.input_current 输入电流
   * @param {string} params.output_voltage 输出电压
   * @param {string} params.output_current 输出电流
   * @param {string} params.frequency 频率
   * @param {string} params.auxiliary_power_voltage 辅助电源电压
   * @returns {Promise<object>} 空body
   */
  createEntity(params) {
    return axios.post(`/backend/ev_charging_piles`, params)
  },
  /**
   *
   * 更新充电桩
   *
   * @param {string} id 充电桩 id
   * @param {object} params 参数
   * @param {string} params.name 桩名
   * @param {string} params.serial_number 编号
   * @param {string} params.created_at 创建时间
   * @param {string} params.updated_at 更新时间
   * @param {string} params.guns_count 枪口数量
   * @param {string} params.description 备注
   * @param {string} params.ev_charging_station 所属充电站
   * @param {string} params.charger_brand 桩品牌
   * @param {string} params.device_name 设备名称
   * @param {string} params.product_name 产品名称
   * @param {string} params.product_model 型号
   * @param {string} params.manufactured_number 出厂编号
   * @param {string} params.manufactured_date 出厂日期
   * @param {string} params.manufacturer 制造商
   * @param {string} params.plug 插头
   * @param {string} params.charging_mode 充电模式
   * @param {string} params.phase_number 相数
   * @param {string} params.certification 质量认证
   * @param {string} params.protection_level 防护等级
   * @param {string} params.temperature 工作温度
   * @param {string} params.standard 标准
   * @param {string} params.status 状态
   * @param {string} params.business_status 业务状态
   * @param {string} params.open 是否开放
   * @param {string} params.charger_type 电桩类型
   * @param {string} params.plug_type 枪口类型
   * @param {string} params.max_power 最大输出功率
   * @param {string} params.max_current 最大输出电流
   * @param {string} params.input_voltage 输入电压
   * @param {string} params.input_current 输入电流
   * @param {string} params.output_voltage 输出电压
   * @param {string} params.output_current 输出电流
   * @param {string} params.frequency 频率
   * @param {string} params.auxiliary_power_voltage 辅助电源电压
   * @returns {Promise<object>} 空body
   */
  updateEntity(id, params) {
    return axios.put(`/backend/ev_charging_piles/${id}`, params)
  },
  /**
   *
   * 删除充电桩
   *
   * @param {string} id 充电桩Id
   * @returns {Promise<object>} 充电桩详情
   */
  deleteEntity(id) {
    return axios.delete(`/backend/ev_charging_piles/${id}`)
  },
  /**
   * 获取桩业务状态数量
   *
   * @returns {Promise<object>} {}
   */
  getPileStatusCount() {
    return axios.get(`/backend/ev_charging_piles/status_count`)
  },
  /**
   * 创建枪口
   *
   * @param {string} id 充电桩Id
   * @param {object} params 参数
   * @param {string} params.serial_number 枪口编号
   * @param {string} params.voltage_upper_limits 电压上限
   * @param {string} params.voltage_lower_limits 电压下限
   * @param {string} params.current 电流
   * @param {string} params.power 功率
   * @param {string} params.gun_type 枪口类型
   * @returns {Promise<object>} 空body
   */
  createGun(id, params) {
    return axios.post(`/backend/ev_charging_piles/${id}/ev_charging_gun`, params)
  },
  /**
   * 创建枪口
   *
   * @param {string} id 充电桩Id
   * @param {object} params 参数
   * @param {Array<string>} params.ev_charging_pile_names 充电桩名
   * @param {Array<string>} params.gun_one_sns 枪1编号
   * @param {?Array<string>} params.gun_two_sns 枪2编号
   * @returns {Promise<object>} 空body
   */
  createClone(id, params) {
    return axios.post(`/backend/ev_charging_piles/${id}/clone`, params)
  },
  /**
   * 获取电桩来源信息
   * 包括来源站桩ID、名称、来源类型
   *
   * @param {string} id 充电桩ID
   * @returns {object}} { station_id: '', charger_id: '', source_type: 'Charger' }
   */
  getSource(id) {
    return axios.get(`/backend/v2/ev_charging_piles/${id}/source`)
  }
}
